import _ from '@/utils/lodash-optimized'

import http from './http'

const url = ({ patientId }) => `/behavioral/${patientId}`

const get = params => http.getRequest(url(params))

const put = _.debounce(
  (params, options, resolve, reject) =>
    http
      .putRequest(url(params), _.pick(params, [ 'data' ]), options)
      .then(resolve)
      .catch(reject),
  500
)

const publish = params =>
    http.postRequest(url(params), {})

const set = (params, options) =>
  new Promise((resolve, reject) => put(params, options, resolve, reject))

const discard = params =>
  http.deleteRequest(url(params))

export default {
  get,
  set,
  publish,
  discard
}
